/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FirebaseUserCourses } from '../models/FirebaseUserCourses';
import type { ProfileOwnEnrolledNoticesUpdateDto } from '../models/ProfileOwnEnrolledNoticesUpdateDto';
import type { ProfileOwnEnrolledProgressUpdateDto } from '../models/ProfileOwnEnrolledProgressUpdateDto';
import type { SuccessResponse } from '../models/SuccessResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProfileEnrolledService {

    /**
     * @param courseId
     * @returns FirebaseUserCourses
     * @throws ApiError
     */
    public static fetchForCourse(
        courseId: string,
    ): CancelablePromise<FirebaseUserCourses> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/course-enrolled/{courseId}',
            path: {
                'courseId': courseId,
            },
        });
    }

    /**
     * @param courseId
     * @param requestBody
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static updateProgressCourse(
        courseId: string,
        requestBody: ProfileOwnEnrolledProgressUpdateDto,
    ): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/course-enrolled-progress/{courseId}',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param courseId
     * @param requestBody
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static updateNoticesCourse(
        courseId: string,
        requestBody: ProfileOwnEnrolledNoticesUpdateDto,
    ): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/course-enrolled-notices/{courseId}',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
